module.exports = __webpack_public_path__ + "static/media/Chevron-right-line.22f26198.svg";